module.exports = __webpack_public_path__ + "img/gq8.d2d6dce5.png";